import React, { useState } from "react";
import "./ProductsPage.css";
import logo from "../../assets/logo.png";

function ProductsPage() {
  const [submitted, setSubmitted] = useState(false);

  const handleNotify = (e) => {
    e.preventDefault();
    setSubmitted(true); // hook up to your backend later
  };

  return (
    <section className="products-comingsoon">
      {/* background glow */}
      <div className="pc-bg" aria-hidden="true" />

      <div className="content">
        <img src={logo} alt="New Alubomulla Trade Center" className="logo" />

        <h1 className="headline">
          Products are almost here |
          <span className="highlight"> stay tuned!</span>
        </h1>

        <p className="sub">
          We’re stocking top-brand tools, paint, plumbing, and building materials.
          A clean, searchable catalog with categories and filters is on the way.
        </p>

        {/* progress */}
        <div className="progress">
          <div className="bar" />
        </div>
        <div className="eta">Launching soon • Panadura since 2010</div>

        

        {/* quick links */}
        <div className="actions">
          <a href="/" className="btn btn-primary">Go Home</a>
        </div>

        {/* skeleton preview of upcoming cards */}
        <div className="skeleton-row" aria-hidden="true">
          <div className="skeleton-card" />
          <div className="skeleton-card" />
          <div className="skeleton-card" />
        </div>

        {/* category chips */}
        <div className="chips">
          <span className="chip">Power Tools</span>
          <span className="chip">Paint</span>
          <span className="chip">Plumbing</span>
          <span className="chip">Electrical</span>
          <span className="chip">Cement & Blocks</span>
        </div>
      </div>
    </section>
  );
}

export default ProductsPage;
